import React from 'react';
import {Link} from 'react-router-dom';
import ContentWrapper from '../Layout/ContentWrapper';
import {Button, UncontrolledDropdown, DropdownItem, DropdownToggle, DropdownMenu, UncontrolledButtonDropdown} from 'reactstrap';
import axios from 'axios';
import {API_ROOT} from '../../api-config';
import Swal from 'sweetalert2'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import 'moment-timezone';
import {getDrivers} from "../Drivers/DriverFunctions";
import getCustomers from "../Customers/CustomerFunctions";
import getLocations from "../Locations/LocationFunctions";
import {getEquipment} from "../Equipment/EquipmentFunctions";
import money from "money-math";
import {toast} from "react-toastify";

moment.tz.setDefault("America/Halifax");

class LoadsList extends React.Component {
    constructor(props) {
        super(props);

        this.updateDates = this.updateDates.bind(this);
        this.goToLoad = this.goToLoad.bind(this);
        this.exportDailyTruckLoads = this.exportDailyTruckLoads.bind(this);

        this.state = {
            vehicles: {},
            vehicles_sort: [],
            equipment: {},
            equipment_sort: [],
            customers: {},
            customers_sort: [],
            loading: true,
            loads: {},
            loads_sort: [],
            locations: [],
            locations_sort: {},
            customer_id: (localStorage.getItem('customer_id') != null && localStorage.getItem('customer_id') != 'null' ? localStorage.getItem('customer_id') : null),
            vehicle_id: (localStorage.getItem('vehicle_id') != null && localStorage.getItem('vehicle_id') != 'null' ? localStorage.getItem('vehicle_id') : null),
            origin: (localStorage.getItem('origin') != null && localStorage.getItem('origin') != 'null' ? localStorage.getItem('origin') : null),
            destination: (localStorage.getItem('destination') != null && localStorage.getItem('destination') != 'null' ? localStorage.getItem('destination') : null),
            driver_id: (localStorage.getItem('driver_id') != null && localStorage.getItem('driver_id') != 'null' ? localStorage.getItem('driver_id') : null),
            drivers: {},
            drivers_sort: [],
            templates: [],
            startDate: (localStorage.getItem('acc_startDate') != null ? moment(localStorage.getItem('acc_startDate')) : moment().subtract(1, 'day').startOf('day')),
            endDate: (localStorage.getItem('acc_endDate') != null ? moment(localStorage.getItem('acc_endDate')) : moment().add(6, 'days')),
            ranges: {
                'Today': [moment(), moment().startOf('day')],
                'Yest. +7 Days': [moment().subtract(1, 'day').add(6, 'days'), moment().startOf('day')],
                'Next 30 Days': [moment().add(30, 'days'), moment().startOf('day')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment().endOf('day')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'All Time': [moment("01 Jan 2023"), moment("31 Dec 2024")]
            },
            sort: (localStorage.getItem('sort2') != null ? localStorage.getItem('sort2') : "load_id"),
            sort_order: (localStorage.getItem('sort_order2') != null ? localStorage.getItem('sort_order2') * 1 : -1),
            status: (localStorage.getItem('status') != null && localStorage.getItem('status') != 'null' ? localStorage.getItem('status') : null),
            statuses: {0: "Draft", 1: "Scheduled", 2: "Started", 3: "Completed", 4: "Billed", 5: "Billed & Sent"}
        };
    }

    componentDidMount() {
        document.title = "Loads | Trucking Co Ltd";
        var self = this;
        getCustomers('list',function (customers) {
            getDrivers(function (drivers) {
                getEquipment(0, function (equipment) {
                    getLocations(function (location_response) {
                        var drivers_sort = [];
                        for (const driver_id of Object.keys(drivers)) {
                            drivers_sort.push(drivers[driver_id]);
                        }
                        var drivers_sort = drivers_sort.sort(function (a, b) {
                            if (a.first_name < b.first_name) {
                                return -1
                            } else {
                                return 1
                            }
                        });
                        var customers_sort = [];
                        for (const customer_id of Object.keys(customers)) {
                            customers_sort.push(customers[customer_id]);
                        }
                        var customers_sort = customers_sort.sort(function (a, b) {
                            if (a.name < b.name) {
                                return -1
                            } else {
                                return 1
                            }
                        });
                        var vehicles_sort = [];
                        for (const vehicle_id of Object.keys(equipment)) {
                            if (equipment[vehicle_id].customer_id == 0) {
                                vehicles_sort.push(equipment[vehicle_id])
                            }
                        }
                        vehicles_sort = vehicles_sort.sort(function (a, b) {
                            if (a.name < b.name) {
                                return -1
                            } else {
                                return 1
                            }
                        });
                        self.setState({
                            vehicles_sort:vehicles_sort,
                            customers: customers,
                            equipment: equipment,
                            locations: location_response.locations,
                            locations_sort: location_response.locations_sort,
                            drivers: drivers,
                            drivers_sort: drivers_sort,
                            customers_sort: customers_sort,
                        }, function () {
                            this.update_load();
                            axios.get(API_ROOT + '/loads/templates')
                                .then(function (response) {
                                    self.setState({
                                        templates: response.data,
                                    })
                                })
                        });
                    });
                });
            });
        });
    }

    update_load() {
        var self = this;
        axios.defaults.withCredentials = true;
        axios.get(API_ROOT + '/loads/?customer_id=' + self.state.customer_id + "&vehicle_id=" + self.state.vehicle_id + "&driver_id=" + self.state.driver_id + "&equipment_id=" + self.state.equipment_id + "&origin=" + self.state.origin + "&destination=" + self.state.destination + "&startDate=" + self.state.startDate.valueOf() + "&endDate=" + self.state.endDate.valueOf() + "&status=" + self.state.status)
            .then(function (response) {
                self.setState({
                        loads: response.data,
                        loading: false,
                    }
                );
                self.onSort(null, self.state.sort)
            })
            .catch(function (error) {
                if (error.response.status === 401) {
                    self.props.userSignOut()
                } else {
                    Swal("Error", error.response.data.Message, "error");
                }
            });
    }

    // on date range change
    updateDates(event, picker) {
        if (event.type == "apply") {
            localStorage.setItem('acc_startDate', picker.startDate);
            localStorage.setItem('acc_endDate', picker.endDate);
            this.setState({
                startDate: picker.startDate,
                endDate: picker.endDate
            }, function () {
                this.update_load()
            });
        }
    }

    changeDriver = (driver_id) => {
        localStorage.setItem('driver_id', driver_id);
        this.setState({
            driver_id: driver_id,
        }, function () {
            this.update_load()
        });
    };

    changeCustomer = (customer_id) => {
        localStorage.setItem('customer_id', customer_id);
        this.setState({
            customer_id: customer_id,
        }, function () {
            this.update_load()
        });
    };

    createLoad = (template_id) => {
        var self = this;
        axios.defaults.withCredentials = true;
        axios.post(API_ROOT + '/loads/false/template/' + template_id)
            .then(function (response) {
                self.props.history.push("/loads/" + response.data.load_id);
                toast.success("Load Created", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            })
            .catch(function (error) {
                if (typeof error.response != "undefined") {
                    if (error.response.status === 401) {
                        self.props.userSignOut()
                    } else {
                        Swal("Error", error.response.data.Message, "error");
                    }
                }
            });
    };

    updateValue(event, name, value) {
        if (event.target) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (typeof name == "undefined") {
            name = event.target.name
        }
        if (typeof value == "undefined") {
            value = event.target.value
        }
        localStorage.setItem(name, value);
        this.setState({
            [name]: value
        }, function () {
            this.update_load()
        });
    }

    goToLoad = (load_id) => {
        this.props.history.push("/loads/" + load_id);
    };

    onSort(event, sortKey) {
        localStorage.setItem('sort2', sortKey);
        localStorage.setItem('sort_order2', this.state.sort_order);
        var sort_order = this.state.sort_order * -1;
        if (sortKey != this.state.sort) {
            sort_order = 1;
        }

        function format_search_val(val) {
            if (typeof val == "undefined") {
                return 1;
            } else if (isNaN(val)) {
                return val.toLowerCase();
            } else {
                return parseFloat(val);
            }
        }

        var loads_sort = [];
        for (const load_id of Object.keys(this.state.loads)) {
            loads_sort.push(this.state.loads[load_id])
        }
        var loads = loads_sort.sort((a, b) => {
            if (typeof format_search_val(a[sortKey]) == "string" && typeof format_search_val(b[sortKey]) != "string") {
                return (sort_order == -1 ? -1 : 1);
            } else {
                if (format_search_val(a[sortKey]) > format_search_val(b[sortKey])) {
                    return (sort_order == -1 ? -1 : 1);
                }
                if (format_search_val(a[sortKey]) < format_search_val(b[sortKey])) {
                    return (sort_order == -1 ? 1 : -1);
                }
            }
            return 0;
        });
        this.setState({
            sort: sortKey,
            sort_order: sort_order,
            loads_sort: loads
        });
    }

    exportDailyTruckLoads = () => {
        // Get all unique truck IDs that have loads in the period
        const trucks = new Set();
        this.state.loads_sort.forEach(load => {
            if (load.vehicle_id) trucks.add(load.vehicle_id);
        });

        // Create a date range array
        const dates = [];
        let currentDate = moment(this.state.startDate);
        const endDate = moment(this.state.endDate);
        while (currentDate <= endDate) {
            dates.push(currentDate.format('YYYY-MM-DD'));
            currentDate = currentDate.clone().add(1, 'days');
        }

        // Create CSV rows - one row per truck per day
        const csvRows = [];
        
        // Add header row
        csvRows.push(['Date', 'Truck #', 'Load(s)']);

        // For each date in the range
        dates.forEach(date => {
            // For each truck
            trucks.forEach(truckId => {
                // Find loads for this truck on this date
                const loadsForTruck = this.state.loads_sort.filter(load => {
                    const loadDate = moment(load.start).format('YYYY-MM-DD');
                    return load.vehicle_id === truckId && loadDate === date;
                });

                // Get truck name
                const truckName = this.state.equipment[truckId] ? this.state.equipment[truckId].name : '';

                // Create load information string
                const loadInfo = loadsForTruck.map(load => {
                    return `Load #${load.load_id}`;
                }).join('; ');

                // Add row for this truck and date
                csvRows.push([
                    date,
                    truckName,
                    loadInfo
                ]);
            });
        });

        // Convert rows to CSV content
        const csvContent = csvRows.map(row => 
            row.map(cell => {
                // Escape cells that contain commas or quotes
                if (typeof cell === 'string' && (cell.includes(',') || cell.includes('"'))) {
                    return `"${cell.replace(/"/g, '""')}"`;
                }
                return cell;
            }).join(',')
        ).join('\n');

        // Create and trigger download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `daily_truck_loads_${moment().format('YYYY-MM-DD')}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    render() {

        // date range selector variables
        let start = this.state.startDate.format('MMM. D/YY');
        let end = this.state.endDate.format('MMM. D/YY');
        let label = start + ' - ' + end;
        if (start === end) {
            label = start;
        }

        return (
            <ContentWrapper>
                <div className="content-heading">
                    <div>Loads List</div>
                    <div className="ml-auto">
                        <UncontrolledDropdown group>
                            <Link to="loads/create" className="btn btn-primary">
                                <i className="fas fa-plus"></i> Load
                            </Link>
                            <DropdownToggle caret color="primary" className="pl-2 pr-2"/>
                            <DropdownMenu>
                                <DropdownItem header>
                                    Load Templates:
                                </DropdownItem>
                                {Object.keys(this.state.templates).map((key, i) => {
                                    return (<DropdownItem key={key}
                                                          onClick={() => this.createLoad(this.state.templates[key].template_id)}>{this.state.templates[key].name}</DropdownItem>)
                                })}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                </div>
                <div className="mb-3 form-inline" style={{zIndex: 1000}}>
                    <DateRangePicker
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        ranges={this.state.ranges}
                        onEvent={this.updateDates}
                        autoUpdateInput={true}
                    >
                        <button type="button" className="btn btn-primary selected-date-range-btn mr-1">
                            Summary Period: <b>{label}</b> <span className="fas fa-caret-down fa-sm"></span>
                        </button>
                    </DateRangePicker>
                    <UncontrolledButtonDropdown className="mr-1">
                        <DropdownToggle color={(this.state.driver_id == null?"primary":"warning")} caret style={{fontSize: '13px', width: 'auto'}}>
                            {(this.state.driver_id == null || typeof this.state.drivers[this.state.driver_id]=="undefined" || typeof this.state.drivers[this.state.driver_id].last_name=="undefined" ? "All Drivers" : this.state.drivers[this.state.driver_id].first_name)} {(this.state.driver_id == null || typeof this.state.drivers[this.state.driver_id]=="undefined" || typeof this.state.drivers[this.state.driver_id].last_name=="undefined" ? "" : this.state.drivers[this.state.driver_id].last_name)}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem key="null" onClick={() => this.updateValue(false, 'driver_id', null)}>All Drivers</DropdownItem>
                            <DropdownItem divider/>
                            {Object.keys(this.state.drivers_sort).map((key, i) => {
                                return (<DropdownItem key={key}
                                                      onClick={() => this.updateValue(false, 'driver_id', this.state.drivers_sort[key].driver_id)}>{this.state.drivers_sort[key].first_name} {this.state.drivers_sort[key].last_name}</DropdownItem>)
                            })}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                    <UncontrolledButtonDropdown className="mr-1">
                        <DropdownToggle color={(this.state.customer_id == null?"primary":"warning")} caret style={{fontSize: '13px', width: 'auto'}}>
                            {(this.state.customer_id == null || typeof this.state.customers[this.state.customer_id]=="undefined" ? "All Customers" : this.state.customers[this.state.customer_id].name)}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem key="null" onClick={() => this.updateValue(false, 'customer_id', null)}>All Customers</DropdownItem>
                            <DropdownItem divider/>
                            {Object.keys(this.state.customers_sort).map((key, i) => {
                                return (<DropdownItem key={key}
                                                      onClick={() => this.updateValue(false, 'customer_id', this.state.customers_sort[key].customer_id)}>{this.state.customers_sort[key].name}</DropdownItem>)
                            })}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                    <UncontrolledButtonDropdown className="mr-1">
                        <DropdownToggle color={(this.state.vehicle_id == null?"primary":"warning")} caret style={{fontSize: '13px', width: 'auto'}}>
                            {(this.state.vehicle_id == null || typeof this.state.equipment[this.state.vehicle_id] == "undefined" ? "All Vehicles" : this.state.equipment[this.state.vehicle_id].name)}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem key="null" onClick={() => this.updateValue(false, 'vehicle_id', null)}>All Vehicles</DropdownItem>
                            <DropdownItem divider/>
                            {this.state.vehicles_sort.map((equipment, i) => {
                                return (<DropdownItem key={equipment.equipment_id}
                                                      onClick={() => this.updateValue(false, 'vehicle_id', equipment.equipment_id)}>{equipment.name}</DropdownItem>)
                            })}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                    <UncontrolledButtonDropdown className="mr-1">
                        <DropdownToggle color={(this.state.origin == null?"primary":"warning")} caret style={{fontSize: '13px', width: 'auto'}}>
                            {(this.state.origin == null || typeof this.state.locations[this.state.origin]=="undefined" ? "All Start Points" : this.state.locations[this.state.origin].name)}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem key="null" onClick={() => this.updateValue(false, 'origin', null)}>All Start Points</DropdownItem>
                            <DropdownItem divider/>
                            {Object.keys(this.state.locations_sort).map((key, i) => {
                                return (<DropdownItem key={key}
                                                      onClick={() => this.updateValue(false, 'origin', this.state.locations_sort[key].location_id)}>{this.state.locations_sort[key].name}</DropdownItem>)
                            })}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                    <UncontrolledButtonDropdown className="mr-1">
                        <DropdownToggle color={(this.state.destination == null?"primary":"warning")} caret style={{fontSize: '13px', width: 'auto'}}>
                            {(this.state.destination == null  || typeof this.state.locations[this.state.destination]=="undefined" ? "All End Points" : this.state.locations[this.state.destination].name)}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem key="null" onClick={() => this.updateValue(false, 'destination', null)}>All End Points</DropdownItem>
                            <DropdownItem divider/>
                            {Object.keys(this.state.locations_sort).map((key, i) => {
                                return (<DropdownItem key={key}
                                                      onClick={() => this.updateValue(false, 'destination', this.state.locations_sort[key].location_id)}>{this.state.locations_sort[key].name}</DropdownItem>)
                            })}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                    <UncontrolledButtonDropdown className="mr-1">
                        <DropdownToggle color={(this.state.status == null?"primary":"warning")} caret style={{fontSize: '13px', width: 'auto'}}>
                            {(this.state.status == null || typeof this.state.statuses[this.state.status]=="undefined" ? "All Statuses" : this.state.statuses[this.state.status])}
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem key="null" onClick={() => this.updateValue(false, 'status', null)}>All Statuses</DropdownItem>
                            <DropdownItem divider/>
                            {Object.keys(this.state.statuses).map((key, i) => {
                                return (<DropdownItem key={key} onClick={() => this.updateValue(false, 'status', key)}>{this.state.statuses[key]}</DropdownItem>)
                            })}
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                    <Button color="light" className="ml-auto" onClick={this.exportDailyTruckLoads}>
                        <i className="fas fa-file-export"></i> Daily Summary
                    </Button>
                </div>
                <div className={(this.state.loading ? "card card-default whirl traditional" : "card card-default")}>
                    <div>
                        <div className="card-header">
                            <div className="card-title">{this.state.loads_sort.length} Loads</div>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className={(this.state.loads_sort.length > 0 ? "table table-hover table-pointer text-right" : "d-none")}>
                                    <thead>
                                    <tr>
                                        <th className="text-left" onClick={e => this.onSort(e, 'name')}><i className="fas fa-sort"></i> Load #</th>
                                        <th className="text-left" onClick={e => this.onSort(e, 'invoice_id')}><i className="fas fa-sort"></i> Inv. #</th>
                                        <th className="text-left" onClick={e => this.onSort(e, 'errors')}><i className="fas fa-sort"></i> Alerts</th>
                                        <th className="text-left" onClick={e => this.onSort(e, 'start')}><i className="fas fa-sort"></i> Start Time</th>
                                        <th className="text-left" onClick={e => this.onSort(e, 'end')}><i className="fas fa-sort"></i> End Time</th>
                                        <th className="text-left" onClick={e => this.onSort(e, 'description')}><i className="fas fa-sort"></i> Description</th>
                                        <th className="text-left" onClick={e => this.onSort(e, 'driver_id')}><i className="fas fa-sort"></i> Driver(s)</th>
                                        <th className="text-left" onClick={e => this.onSort(e, 'customer_id')}><i className="fas fa-sort"></i> Customer</th>
                                        <th className="text-left" onClick={e => this.onSort(e, 'vehicle_id')}><i className="fas fa-sort"></i> Truck</th>
                                        <th className="text-left" onClick={e => this.onSort(e, 'equipment_id')}><i className="fas fa-sort"></i> Equipment</th>
                                        <th className="text-right" onClick={e => this.onSort(e, 'total_total')}><i className="fas fa-sort"></i> Total</th>
                                        <th className="text-right" onClick={e => this.onSort(e, 'status')}><i className="fas fa-sort"></i> Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {Object.entries(this.state.loads_sort).map(([key, load]) => {
                                        var errors = JSON.parse(load.errors);
                                        var warnings = JSON.parse(load.warnings);
                                        if (errors == null) {
                                            errors = []
                                        }
                                        if (warnings == null) {
                                            warnings = []
                                        }
                                        var drivers = JSON.parse("[" + load.drivers + "]");
                                        var equipment = JSON.parse("[" + load.equipment + "]");
                                        if (load.load_id > 0) {
                                            return (
                                                <tr key={key} onClick={this.goToLoad.bind(this, load.load_id)}>
                                                    <td className="text-left">{load.load_id}</td>
                                                    <td className="text-left">{(load.invoice_id==null?"":load.invoice_id)}</td>
                                                    <td className="text-left">
                                                        <div className={(errors.length > 0 ? "badge rounded-pill bg-danger ml-1" : "d-none")}>
                                                            <i className="fas fa-exclamation-triangle"></i> x{errors.length}
                                                        </div>
                                                        <div className={(warnings.length > 0 ? "badge rounded-pill bg-warning ml-1" : "d-none")}>
                                                            <i className="fas fa-exclamation-circle"></i> x{warnings.length}
                                                        </div>
                                                    </td>
                                                    <td className="text-left">{(load.start == null ? "--" : moment(load.start).format("MMM. D/YY HH:mm"))}</td>
                                                    <td className="text-left">{(load.start == null ? "--" : moment(load.end).format("MMM. D/YY HH:mm"))}</td>
                                                    <td className="text-left">{load.description}</td>
                                                    <td className="text-left">
                                                        {Object.keys(drivers).map((key, i) => {
                                                            return (
                                                                <>
                                                                    {(typeof this.state.drivers[drivers[key]] == "undefined" || typeof this.state.drivers[drivers[key]].last_name == "undefined" ? "" : this.state.drivers[drivers[key]].first_name + " " + this.state.drivers[drivers[key]].last_name)}
                                                                    <span className={(drivers.length - 1 == i ? "d-none" : "")}>, </span>
                                                                </>
                                                            )
                                                        }, this)}
                                                    </td>
                                                    <td className="text-left">{(typeof this.state.customers[load.customer_id] == "undefined" ? "" : this.state.customers[load.customer_id].name)}</td>
                                                    <td className="text-left">{(typeof this.state.equipment[load.vehicle_id] == "undefined" ? "" : this.state.equipment[load.vehicle_id].name)}</td>
                                                    <td className="text-left">
                                                        {Object.keys(equipment).map((key, i) => {
                                                            return (
                                                                <>
                                                                    {(typeof this.state.equipment[equipment[key]] == "undefined" ? "" : this.state.equipment[equipment[key]].name)}
                                                                    <span className={(equipment.length - 1 == i ? "d-none" : "")}>, </span>
                                                                </>
                                                            )
                                                        }, this)}
                                                    </td>
                                                    <td className="text-right">{(load.total_margin == null ? "NA" : "$" + money.format("USD", money.floatToAmount(load.total_total)))}</td>
                                                    <td className="text-left">
                                                        <span className={(load.status != 0 ? "d-none" : "badge bg-light text-dark")}>DRAFT</span>
                                                        <span className={(load.status != 1 ? "d-none" : "badge bg-info")}>SCHEDULED</span>
                                                        <span className={(load.status != 2 ? "d-none" : "badge bg-warning")}>STARTED</span>
                                                        <span className={(load.status != 3 ? "d-none" : "badge bg-success")}>COMPLETED</span>
                                                        <span className={(load.status != 4 ? "d-none" : "badge bg-pink")}>BILLED</span>
                                                        <span className={(load.status != 5 ? "d-none" : "badge bg-teal")}>BILLED & SENT</span>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        );
    }
}

export default (LoadsList);